/**
 * Règles de verrouillage partagées Affaire/Tache : un dossier clôturé ou une
 * tâche résolue (ou rattachée à un dossier clôturé) ne peuvent plus être
 * modifiés — sauf via le Path (changement d'étape/statut), qui reste la
 * seule voie pour les rouvrir. Voir aussi le verrouillage équivalent côté
 * backend (AffaireController/TacheController::update()/changeStep()).
 */

export function isAffaireLocked(affaire) {
  return !!affaire?.done;
}

export function isTacheLocked(tache) {
  return !!tache?.statut?.resolu || !!tache?.affaire?.done;
}

/**
 * Le Path d'une tâche reste actif même si la tâche elle-même est résolue
 * (pour permettre de la rouvrir), mais se verrouille si son dossier parent
 * est clôturé (il faut d'abord rouvrir le dossier).
 */
export function canEditTacheStep(tache, canManageTache) {
  return !!canManageTache && !tache?.affaire?.done;
}
